import { AddOrRenameCourseModal } from "./AddOrRenameCourseModal";

import { CourseType } from "components/server-types";
import { t } from "i18n/i18n";
import { showConfirmationModal } from "mds/components/Modal";
import { ADMIN_COURSE_EVENT_PREFIX } from "utils/amplitude";

export const showAddCourseModal = (defaultGroupingId?: string) => {
  showConfirmationModal({
    title: t("home.courses.add_course_heading"),
    hideCancelConfirmButtons: true,
    children: (onClose) => (
      <AddOrRenameCourseModal
        defaultGroupingId={defaultGroupingId}
        eventPrefix={`${ADMIN_COURSE_EVENT_PREFIX}Add Course`}
        onClose={onClose}
      />
    ),
  });
};

export const showRenameCourseModal = (course: CourseType) => {
  showConfirmationModal({
    title: t("home.courses.rename_course_heading"),
    hideCancelConfirmButtons: true,
    children: (onClose) => (
      <AddOrRenameCourseModal
        course={course}
        eventPrefix={`${ADMIN_COURSE_EVENT_PREFIX}Rename Course`}
        onClose={onClose}
      />
    ),
  });
};
